import React from "react";

// MUI Components:
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Box     from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";

// Styled comp:
import { styled } from '@mui/material/styles';


/******************************************************
 * Component Style
******************************************************/

    const SectionTitle = styled(Typography) ({
        width:'100%',
        fontWeight:'bold',
        marginBottom:'0.3rem'
    });

    const ControlLabel = styled(Typography) ({
        width:'100%'

    });

    const CustTextFld =  styled(TextField) ({
        width:'100%',
        size:'small'
    });

    const InputContainer = styled(FormControl) ({
        width:'100%',
        [`& ${ControlLabel}`]: ({}),
        [`& ${CustTextFld}`]: ({})
        
        })
    


    const SectionContainer =  styled(Box)({
        width:'100%',
        marginTop:'1rem',
        marginBottom:'1rem',
        [`& ${InputContainer}`]: ({})
    })

function ItemDescriptionView({handleChange}) {

    return(

            <SectionContainer>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md:1 }} disableGutters>
                    <SectionTitle variant="h5">Item Description</SectionTitle>
                    <Grid size={{xs: 12, sm:12, md: 12  , lg:12, xl:12}}>
                        <InputContainer>
                            <ControlLabel>Description</ControlLabel>
                            <TextField 
                                required={true}
                                // error={bTextError}
                                multiline
                                onChange={handleChange}
                                aria-label="minimum height"
                                rows={6}
                                
                                placeholder="add a text describtion.."
                                sx={{ marginBottom:'1rem',
                                        width: { xs:'100%',sm: '100%', md:'100%', lg:'20rem', xl:'20rem' } }}                     
                            />
                        </InputContainer>
                    </Grid>
                </Grid>
            </SectionContainer>
    );
}

export default ItemDescriptionView;